<template>
    <div class="flex flex-wrap">
        <div class="md:pl-10 w-full md:pr-20">
            <form method="POST">

                <div class="mb-12">
                    <label for="title" ref="title">
                        Resource Title <span class="text-red">*</span>
                        <div class="text-sm font-sans-book">50 character maximum (including spaces).</div>
                    </label>
                    <input id="title" type="text" name="title"
                        v-validate="'required|max:50'"
                        v-model="form.title">
                        <div class="text-sm font-sans-italic text-gray-dark mt-1">Character count: {{ characterCount }}</div>
                        <span v-show="errors.has('title')" class="error text-error-red text-lg">{{ errors.first('title') }}</span>
                </div>

                <div class="mb-12">
                    <label for="title" ref="types">
                        What type of resource is this? <span class="text-red">*</span>
                        <div class="text-sm font-sans-book">Make up to three choices. Select "Article" when creating a new written resource directly through this site.</div>
                    </label>
                    <div class="group__checkbox">
                        <div class="select-box flex flex-wrap">
                            <label class="text-base font-normal w-full md:w-1/2 md:pr-3" v-for="type in types" :key="type.id">
                                <input name="types" type="checkbox"
                                    v-validate="'required'"
                                    v-model="form.types"
                                    :value="type.id"
                                    :disabled="maxMet && form.types.indexOf(type.id) == -1"
                                >
                                <span class="check inline-block mr-2"></span>
                                <span class="flex-1">{{ type.title }}</span>
                            </label>
                        </div>
                        <span v-show="errors.has('types')" class="error text-error-red text-lg">{{ errors.first('types') }}</span>
                    </div>
                </div>

                <div class="mb-12">
                    <label for="title" ref="price">
                        Is this a paid or free resource? <span class="text-red">*</span>
                    </label>
                    <div class="group__radio">
                        <div class="select-box flex flex-wrap">

                            <label class="text-base font-normal w-full md:w-1/2 md:pr-3"
                                v-for="price in prices" :key="price.id">
                                <input name="price" type="radio"
                                    v-validate="'required'"
                                    v-model="form.price"
                                    :value="price.id">
                                <span class="radio inline-block mr-2"></span> {{ price.price }}
                            </label>

                        </div>
                        <span v-show="errors.has('price')" class="error text-error-red text-lg">{{ errors.first('price') }}</span>
                    </div>
                </div>

                <div class="mb-12">
                    <label for="title" ref="locations">
                        Is this resource only available in a specific location? If so, where?
                        <div class="text-sm font-sans-book mb-2">If the resource is available everywhere or is not limited by location, please leave all boxes unchecked.</div>
                    </label>
                    <div class="group__radio">
                        <div class="select-box flex flex-wrap">
                            <label class="text-base font-normal w-full md:w-1/2 md:pr-3"
                                v-for="location in locations" :key="location.id">
                                <input name="locations" type="checkbox"
                                    v-model="form.locations"
                                    :value="location.id">
                                <span class="check inline-block mr-2"></span>
                                <span class="flex-1">{{ location.title }}</span>
                            </label>
                        </div>

                        <span v-show="errors.has('locations')" class="error text-error-red text-lg">{{ errors.first('locations') }}</span>
                    </div>
                </div>

                <div class="mb-12">
                    <label for="title">
                        If other please share the location so it can be included in future updates.
                    </label>
                    <input id="otherLocation" type="text" name="otherLocation"
                        v-model="form.otherLocation">
                </div>

                <div class="mb-12">
                    <label for="url">
                        If there is one, share a specific website where people can learn more about this resource.
                    </label>
                    <url-input v-model="form.url"></url-input>
                </div>

                <div class="mb-6 border-top flex flex-wrap">
                    <button class="button" @click.stop.prevent="save" :class="{ 'opacity-50 cursor-not-allowed': saving }" :disabled="saving">
                        <template v-if="saving">Processing...</template>
                        <template v-else>Save</template>
                    </button>
                    <div class="mr-0 md:mr-4 mb-4 md:mb-4 w-full md:w-auto" />
                    <button class="button" @click.stop.prevent="saveNext" :class="{ 'opacity-50 cursor-not-allowed': saving }" :disabled="saving">Save & Next</button>
                </div>

            </form>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import resourceSave from "../../../mixins/resource-save";
    import urlFilter from "../../../mixins/url-filter";
    import messaging from "../../../mixins/messaging";
    import UrlInput from "../../global/UrlInput.vue";
    import validation from "../../../mixins/validation";

    export default {
        name: "ResourceCreateBasic",
        mixins: [resourceSave, messaging, urlFilter, validation],
        components: {
            UrlInput
        },
        data: () => ({
            form: {
                title: "",
                types: [],
                price: "",
                locations: [],
                url: "",
                otherLocation: ""
            },
            next: "resource-details"
        }),
        computed: {
            ...mapGetters({
                types: "types",
                locations: "locations",
                prices: "prices",
                resource: "resource",
                resourceValidation: "resourceValidation"
            }),
            characterCount() {
                return this.form.title ? this.form.title.length : 0;
            },
            maxMet() {
                return this.form.types.length >= 3;
            }
        },
        watch: {
            resource(resource) {
                if (!_.isEmpty(resource)) {
                    this.form.title = resource.title;
                    this.form.price = resource.price ? resource.price : "";

                    var url = resource.url;
                    this.form.url = this.filterUrl(url);

                    this.form.otherLocation = resource.otherLocation;

                    if (resource.types.length > 0) {
                        let types = _.map(resource.types, "id");
                        this.form.types = types;
                    }

                    if (resource.locations.length > 0) {
                        let locations = _.map(resource.locations, "id");
                        this.form.locations = locations;
                    }

                    this.$nextTick(function() {
                        this.$store.dispatch("setUnsavedData", false);
                    });
                }
            }
        },
        methods: {
            save() {
                this.saving = true;

                return this.$validator.validateAll().then(result => {
                    if (!result) {
                        this.saving = false;
                        this.gotoFirstValidationError();
                        return;
                    }

                    this.$toasted.show("Resource currently saving...");

                    let route = this.$laroute.route("api.resources.update.basics", {
                        resource: this.resource.id
                    });

                    return axios
                        .put(route, this.form)
                        .then(response => {
                            this.$toasted.show("Resource saved.");

                            let resourceResponse = response.data.data;
                            this.$store.dispatch(
                                "setResourceValidation",
                                resourceResponse
                            );
                            this.$store.dispatch("setUnsavedData", false);

                            this.saving = false;
                        })
                        .catch(error => {
                            console.log(error);
                            this.displayError(error);
                        });
                });
            },
            getFormSettings() {
                this.$store.dispatch("getTypes");
                this.$store.dispatch("getPrices");
                this.$store.dispatch("getLocations");
            }
        },
        mounted() {
            this.getFormSettings();

            const id = this.$route.params.id;
            this.$store.dispatch("getResource", { id: id });
        }
    };
</script>
